import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getDelivery } from "../../REDUX/actions/delivery";
import API from "../../Api/Api";
import { useTranslation } from "react-i18next";

const ValidatePacking = ({
  canUpdate,
  deliveryId,
  ids,
  isValidated,
  field,
  disabled = false,
}) => {
  const { t } = useTranslation("common");
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const updatePacking = async (value) => {
    try {
      for (const id of ids) {
        await API.put(`api/packings/${id}`, {
          data: {
            [field]: value,
          },
        });
      }
      dispatch(
        getDelivery(deliveryId, t("La validation du produit a été mise à jour"))
      );
    } catch (error) {
      console.log(error);
    }
  };
  const handleClick = async (value) => {
    if (!open) {
      setOpen(true);
    } else {
      if (value === true) {
        await updatePacking(true);
      } else if (value === false) {
        await updatePacking(false);
      } else {
        await updatePacking(null);
      }
      setOpen(false);
    }
  };
  if (!open) {
    return (
      <div className="d-flex gap-2 align-items-center justify-content-center">
        <button
          onClick={() => {
            if (canUpdate && !disabled) {
              setOpen(true);
            }
          }}
          className={`size-40px rounded-circle d-flex align-items-center justify-content-center ${
            isValidated === null ? "border border-gray" : "border-0"
          }`}
          style={{
            backgroundColor: isValidated
              ? "#0f9246"
              : isValidated === false
              ? "#ff3131"
              : "#ffffff",
          }}
        >
          {isValidated && <i class="bi bi-check f24 text-white"></i>}
        </button>
      </div>
    );
  }
  return (
    <div className="d-flex gap-2 align-items-center justify-content-center">
      {[true, null, false].map((value) => (
        <button
          onClick={() => handleClick(value)}
          className={`size-40px rounded-circle d-flex align-items-center justify-content-center ${
            value === null ? "border border-gray" : "border-0"
          }`}
          style={{
            backgroundColor:
              value === true
                ? "#0f9246"
                : value === false
                ? "#ff3131"
                : "#ffffff",
          }}
        >
          {value && <i class="bi bi-check f24 text-white"></i>}
        </button>
      ))}
    </div>
  );
};

export default ValidatePacking;
